import mbThreeJsScene from "../Classes/mbThreeJsScene";
// import * as THREE from "three";

export function modelHandlerIntro() {
  const hypoid3DModel =
    globalvars_scene["stylesheet_directory_url"] +
    "/public/models/Getriebe_retopo_anim_reverse_separated.glb";
  const canvasIdIntro = "mb-hypoid-intro";
  const canvasIntro = document.getElementById(canvasIdIntro);

  if (!canvasIntro) return;

  const argsModelIntro = {
    cameraPerspective: {
      fov: 35,
      ascpect: canvasIntro.offsetWidth / canvasIntro.offsetHeight,
      near: 0.1,
      far: 500,
    },
    cameraPosition: {
      x: 0,
      y: 0.05,
      z: 0.3,
    },
    rotation: {
      x: 20,
      y: -28,
      z: 0,
    },
    scale: {
      x: 0.2,
      y: 0.2,
      z: 0.2,
    },
    animateInstantClips: [0, 1],
  };

  let modelLoadEvent = function ($that) {
    // try to fix collor issue of rotating arrows
    let modelScene = $that.modelScene;
    let pfeil = modelScene.children[0].children[0].children[1];

    pfeil.material.metalness = 1;
  };

  const hypoid3DModelIntro = new mbThreeJsScene(
    canvasIdIntro,
    hypoid3DModel,
    argsModelIntro,
    modelLoadEvent
  );
}
